export default function({ state, commit, dispatch }, { id, provider, schedule, note }) {
    let query = {
        note
    }
    if(schedule)
        query['schedule'] = schedule
    return dispatch('post', {
        url: '/provider/' + (state.id ? state.id : provider) + '/patient/' + id + '/chart',
        data: {
            ...query
        }
    }, {
        root: true
    })
    .then((response) => {
        return response
    })
    .catch((error) => {
        throw error
    })
}
